// extracted by mini-css-extract-plugin
export var gif = "_jj-0";